/* eslint-disable no-console */
import { FC, ReactElement, SyntheticEvent, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useAuth } from 'src/contexts/auth.context'
import { loginRequest, windowRedirectToBackend } from 'src/services/api.service'
import { routes } from 'src/navigation/routes'
import { LoginForm, LoginFormValues } from './login-form'

interface LoginProps {
  isLanding: boolean
}

export const Login: FC<LoginProps> = ({ isLanding = false }): ReactElement => {
  const history = useHistory()
  const { setUser, setToken } = useAuth()
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    console.log('Login page')
  }, [])

  const handleSignupLink = (e: SyntheticEvent) => {
    e.preventDefault()
    history.push(routes.register)
  }

  const handleForgotPasswordLink = (e: SyntheticEvent) => {
    e.preventDefault()
    history.push(routes.forgot_password)
  }

  const handleSubmit = async (values: LoginFormValues) => {
    try {
      setError('')
      setIsLoading(true)
      const response = await loginRequest(values)

      const { status, data: { user, token }} = response;

      if (status === 200) {
        setUser(user)
        setToken(token)
        windowRedirectToBackend(token, window.location.href)
      }
    } catch (err) {
      setError(err?.response?.data?.error?.[0] || err?.message)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <LoginForm
      isLoading={isLoading}
      isLanding={isLanding}
      error={error}
      handleSubmit={handleSubmit}
      handleSignupLink={handleSignupLink}
      handleForgotPasswordLink={handleForgotPasswordLink}
    />
  )
}
